@if (state() === "loading") {
  <app-loading />
}

@if (state() === "error") {
  <app-error-data
    [title]="isArabic() ? 'حدث بعض الخطأ' : 'Something went wrong'"
    [showRetry]="true"
    (retry)="retry.emit()" />
}

@if (state() === "success") {
  <app-tables
    [headerItems]="headerItems"
    [rows]="rows()"
    [currentActions]="currentActions()"
    (actionTrigger)="handleAction($any($event))"
    [isFiltersApplied]="isFiltersApplied()"
    [emptyFilterTitle]="isArabic() ? 'لا توجد موردين تطابق معايير البحث.' : 'No suppliers match your criteria.'"
    [emptyContentTitle]="isArabic() ? 'لا توجد موردين' : 'No suppliers found.'"
    [emptyContentDescription]="isArabic() ? 'لا توجد موردين في النظام.' : 'No suppliers found in the system.'" />

}
